function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M28.241 32h9.462L40 28H26z"
}), React.createElement("path", {
  d: "M32.403 32.186L30 36.414 32.607 41l4.603-8.093L40 28z"
}), React.createElement("path", {
  d: "M28.5 18.008l-17.5.004 8.756 15.494L28.508 49l2.487-4.406-3.155-5.71-4.25-7.521-4.912-8.693 9.822-.005 9.822-.004-1.452 2.576h5.046L46 18z"
}), React.createElement("path", {
  d: "M34.827 37H30l6.31 12L39 44.944z"
}), React.createElement("path", {
  d: "M49.5 36.8c-4.292 10.685-15.651 16.663-26.824 14.118-11.173-2.545-18.863-12.863-18.16-24.366.701-11.502 9.59-20.795 20.988-21.946 11.398-1.15 21.944 6.182 24.904 17.314H55C51.976 8.244 39.37-1.078 25.492.1 11.614 1.28.738 12.594.036 26.587-.667 40.579 9.02 52.94 22.709 55.518 36.4 58.098 49.875 50.1 54.253 36.8H49.5z"
}), React.createElement("path", {
  d: "M38.322 23H18.69L11 18h35z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo.971c4c91.svg";
export { SvgComponent as ReactComponent };